import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import foundation from 'foundation-sites'
import mixin from './components/Mixin.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import { ModalPlugin } from 'bootstrap-vue'
import { BModal, VBModal } from 'bootstrap-vue'
//import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import VueApexCharts from 'vue-apexcharts'
import VueSocialSharing from 'vue-social-sharing'

Vue.component('apexchart', VueApexCharts)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(ModalPlugin)
Vue.use(VueSocialSharing)
Vue.component('b-modal', BModal)
Vue.directive('b-modal', VBModal)
Vue.mixin(mixin)
Vue.use(VueAxios, axios)
Vue.use(VueApexCharts)
Vue.prototype.$axios = axios;
Vue.use(foundation);

axios.defaults.baseURL = "/api"
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
